import { Theme } from "theme-ui";

export const text: Theme["text"] = {
  heading: {
    fontFamily: "heading",
    color: "text",
    fontWeight: "heading",
    fontSize: 2,
    mt: 0,
    mb: 3,
    a: {
      color: "inherit"
    }
  },
  brandLarge: {
    fontSize: 7,
    lineHeight: "56px",
    fontWeight: "reg",
    fontFamily: "brand"
  },
  brandMedium: {
    fontSize: 6,
    lineHeight: "32px",
    fontWeight: "reg",
    fontFamily: "brand"
  },
  brandSmall: {
    fontSize: 4,
    lineHeight: "32px",
    fontWeight: "reg",
    fontFamily: "brand"
  },
  heroJumbo: {
    fontSize: 9
  },
  heroHuge: {
    fontWeight: "heading",
    fontSize: 8
  },
  headerLarge: {
    fontWeight: "med",
    fontSize: 7
  },
  headerMedium: {
    fontWeight: "reg",
    letterSpacing: "-0.02em",
    fontSize: 6
  },
  headerSmall: {
    fontWeight: "med",
    fontSize: 5
  },
  headerTiny: {
    fontWeight: "med",
    fontSize: 4
  },
  titleLarge: {
    fontWeight: "med",
    fontSize: 3
  },
  titleMedium: {
    fontWeight: "semi",
    fontSize: 2
  },
  titleSmall: {
    fontWeight: "heading",
    fontSize: 1
  },
  bodyLarge: {
    fontSize: 3,
    fontWeight: "reg",
    lineHeight: "24px",
    letterSpacing: "-0.16px"
  },
  bodyMedium: {
    fontSize: 2,
    fontWeight: "reg",
    lineHeight: "20px"
  },
  bodySmall: {
    fontSize: 1,
    fontWeight: "reg",
    lineHeight: "18px"
  },
  label: {
    fontSize: 2,
    letterSpacing: "0.03em",
    textTransform: "uppercase",
    fontWeight: "bold",
    lineHeight: "18px"
  },
  labelSmall: {
    fontSize: 1,
    letterSpacing: "0.03em",
    textTransform: "uppercase",
    fontWeight: "bold",
    lineHeight: "16px"
  },
  p: {
    mt: 0,
    mb: 3,
    code: {
      variant: "styles.code"
    }
  },
  small: {
    color: "muted",
    fontSize: 0
  },
  a: {
    color: "muted",
    variant: "styles.focus"
  }
};
